import React from 'react';
import ReactDOM from 'react-dom';
import './scss/_confirmationPopup.scss';

function ConfirmationPopup({ 
  isOpen, 
  onClose, 
  onContinue, 
  questionText, 
  cancelText = "Cancel",
  continueText = "Continue" 
}) {
  const handleCancel = () => {
    if (onClose) {
      onClose();
    }
  };

  const handleContinue = () => {
    if (onContinue) {
      onContinue();
    }
    if (onClose) {
      onClose();
    }
  };

  if (!isOpen) return null;

  const content = (
    <>
      <div className="confirm-dialog-overlay" onClick={handleCancel}></div>
      <div className="confirm-dialog-container">
        {/* Content */}
        <div className="confirm-dialog-content">
          <div className="confirm-dialog-question">
            <p className="confirm-dialog-question-text">{questionText}</p>
          </div>
        </div>

        {/* Footer */}
        <div className="confirm-dialog-footer">
          <div className="confirm-dialog-actions">
            <button className="confirm-dialog-btn confirm-dialog-btn--cancel" onClick={handleCancel}>
              <span>{cancelText}</span>
            </button>
            <button className="confirm-dialog-btn confirm-dialog-btn--primary" onClick={handleContinue}>
              <span>{continueText}</span>
            </button>
          </div>
        </div>
      </div>
    </>
  );

  return typeof document !== "undefined" ? ReactDOM.createPortal(content, document.body) : content;
}

export default ConfirmationPopup;
